<div class="app-content">
  <my-toolbar title="{{ 'Notifications' | translate }}"></my-toolbar>
  <div class="list-container">
    <user-notifications [viewType]="'fullview'"></user-notifications>
  </div>
</div>
